import { InjectionToken } from '@angular/core';

export const RXAP_DEFINITION_METADATA = new InjectionToken('rxap/definition/metadata');
